import React from "react";

import { useHistory, useLocation } from "react-router-dom";

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";
import { useNewSubscriberContext } from "../../Context/NewSubsciberContext";

const NewSubscriberStepper = (props) => {
  const { skipKyc, kycDetails } = useNewSubscriberContext();
  const location = useLocation();
  const history = useHistory();
  const { pathname } = location;
  const steps = [
    {
      validSteps: [0, 1],
      validPathName: [
        "/nps/AddSubs",
        "/nps/AddSubs/new-reg",
        "/nps/AddSubs/kyc-details",
      ],
      value: "KYC Details",
      image: "/images/newsletter.png",
    },
    {
      validSteps: [2],
      validPathName: ["/nps/AddSubs/personal-details"],
      value: "Personal Details",
      image: "/images/user_blue_bg.png",
    },
    {
      validSteps: [3],
      validPathName: ["/nps/AddSubs/fatca-details"],
      value: "FATCA Details",
      image: "/images/user_blue_bg.png",
    },
    {
      validSteps: [4],
      validPathName: ["/nps/AddSubs/investment-details"],
      value: "Investment Details",
      image: "/images/accounts.png",
    },
    {
      validSteps: [5],
      validPathName: ["/nps/AddSubs/scheme-details"],
      value: "Scheme Details",
      image: "/images/accounts.png",
    },
    {
      validSteps: [6],
      validPathName: ["/nps/AddSubs/nominee-details"],
      value: "Nominee Details",
      image: "/images/accounts.png",
    },
    {
      validSteps: [7],
      validPathName: ["/nps/AddSubs/bank-details"],
      value: "Bank Details",
      image: "/images/user_blue_bg.png",
    },
    {
      validSteps: [8],
      validPathName: ["/nps/AddSubs/upload-documents"],
      value: "Upload Documents",
      image: "/images/upload.svg",
    },
    {
      validSteps: [9],
      validPathName: ["/nps/AddSubs/subscriber-summary"],
      value: "Summary",
      image: "/images/tic.png",
    },
  ];
  const { active } = props;
  const activeStep = steps.find((step) =>
    step.validPathName.includes(pathname)
  );
  const maxValidateStepNo = activeStep.validSteps.at(-1);

  return (
    <>
      <div className="vertical-stepper-body text-align">
        <div
          className="vertical-stepper-header2"
          onClick={() => history.push("/dashboard")}
        >
          <ArrowBackIosIcon style={{ color: "#007ac8" }} />
          NPS Subscriber Details
        </div>
        <div className="vertical-stepper-body-main">
          {steps.map((step, index) => (
            <div
              style={{
                color: step.validPathName.includes(pathname)
                  ? "#007ac8"
                  : "gray",
                marginBottom: "10px",
                padding: "18px",
                borderLeft:
                  step.validPathName.includes(pathname) && "5px solid #007ac8",
                borderRadius: "8px",
                boxShadow:
                  step.validPathName.includes(pathname) &&
                  "0.3em 0.3em 1em rgba(0, 0, 0, 0.3)",
                background: step.validPathName.includes(pathname) && "#fff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "15px",
              }}
              key={index}
              // onClick={() => {
              //   if (
              //     !step.validPathName.includes(pathname) &&
              //     step.validSteps.some((i) => maxValidateStepNo >= i)
              //   ) {
              //     history.push(step.validPathName[0]);
              //   }
              // }}
            >
              {step.value}
              {step.value == "KYC Details" ? (
                <>
                  {!step.validPathName.includes(pathname) &&
                  step.validSteps.some((i) => maxValidateStepNo >= i) ? (
                    <>
                      {!Boolean(kycDetails?.data?.IdentifierNum) || skipKyc ? (
                        <ErrorOutlineOutlinedIcon
                          style={{ color: "goldenrod" }}
                        />
                      ) : (
                        <CheckCircleOutlineIcon
                          style={{ color: "rgb(109, 219, 109)" }}
                        />
                      )}
                    </>
                  ) : null}
                </>
              ) : (
                <>
                  {!step.validPathName.includes(pathname) &&
                    step.validSteps.some((i) => maxValidateStepNo >= i) && (
                      <>
                        <CheckCircleOutlineIcon
                          style={{ color: "rgb(109, 219, 109)" }}
                        />
                      </>
                    )}
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
export default NewSubscriberStepper;
